import { add_icon } from './icons/add_icons';
import { help_desk } from './icons/help_desk';
import { handover } from './icons/handover';
import { flag1 } from './icons/flag1';
import { forwards } from './icons/forwards';
import { users } from './icons/users';
import { add_users } from './icons/add_users';
import { cross } from './icons/cross';
import { check } from './icons/check';
import { institutions } from './icons/instituation';
import { clarification_alert } from './icons/clarification_alert';
import { pdf } from './icons/pdf';
import { back_arrow_left } from './icons/back_arrow_left';
import { backarrow } from './icons/backarrow';
import { ask_clarification } from './icons/ask_clarification';
import { reports } from './icons/reports';
import { bill_receipts } from './icons/bill_receipts';
import { waiver } from './icons/waive';
import { bills } from './icons/bills';
import { transcations } from './icons/transcations';
import { end_message } from './icons/end_message';
import { searchIcon } from './icons/search';
import { back_arrow } from './icons/back_arrow';
import { forward } from './icons/forward';
import { tune_setting } from './icons/tune_setting';
import { more_menu } from './icons/more_menu';
import { arrow_down } from './icons/arrow_down';
import { star } from './icons/star';
import { sent } from './icons/sent';
import { inbox } from './icons/inbox';
import { notificatioBell } from './icons/notification_bell';
import { trash_inbox } from './icons/trash_inbox';
import { back_notes } from './icons/bank_notes';
import { credit_card } from './icons/credit_card';
import { Injectable } from '@angular/core';
import { settingsSvg } from './icons/settings';
import { menuIcons } from './icons/menu';
import { call_tracking } from './icons/call_tracking';
import { clipboard } from './icons/clipboard';
import { closed_lock } from './icons/closed_lock';
import { document_download } from './icons/document_download';
import { uploadSvg } from './icons/upload';
import { people } from './icons/people';
import { add_shopping_cart } from './icons/add_shopping_cart';
import { data_base } from './icons/data_base';
import { back_icon } from './icons/back_icon';
import { briefcase } from './icons/briefcase';
import { success } from './icons/success';
import { edit } from './icons/edit';
import { trash_delete } from './icons/trash_delete';
import { s_view } from './icons/s_view';
import { calendar_month } from './icons/calendar_month';
import { payment } from './icons/payment';
import { balace } from './icons/balance';
import { message } from './icons/message';
import { paperclip } from './icons/paper-clip';
import { image } from './icons/image';
import { question_mark } from './icons/question_mark';
import { add } from './icons/add';
import { wallet_account } from './icons/wallets';
import { money_wallet } from './icons/money';
import { requisition } from './icons/requisition';
import { Save } from './icons/save';
import { evaluate } from './icons/evaluate';
import { team } from './icons/team';
import { chevron_down } from './icons/chevron_down';
import { chevron_up } from './icons/chevron_up';
import { user_account } from './icons/user_account';
import { tasks } from './icons/tasks';
import { language } from './icons/language';
import { approved_cart } from './icons/approved_cart';
import { done_check } from './icons/done_check';
import { cancelledOptions } from './icons/cancelled-options';
import { redo } from './icons/redo';
import { reply } from './icons/reply';
import { flag2 } from './icons/flag2';
import { post_qualification } from './icons/post-qualification';
import { negotiation } from './icons/negotiation';
import { bidMeeting } from './icons/bidMeeting';
import { siteVisitSvg } from './icons/siteVisit';
import { cart_icon } from './icons/cart_icon';
import { stock } from './icons/stock';
import { complain } from './icons/complain';
import { excel } from './icons/excel';
import { plus } from './icons/plus';
import { minus } from './icons/minus';
import { list } from './icons/list';
import { doc } from './icons/doc';
import { mp3 } from './icons/mp3';
import { mp4 } from './icons/mp4';
import { add_person } from './icons/add_person';
import { upload_file } from './icons/upload_file';
import { facebook } from './icons/facebook';
import { instagram } from './icons/instagram';
import { twitter } from './icons/twitter';
import { youtube } from './icons/youtube';
import { option } from './icons/option';
import { education } from './icons/education';
import { translation } from './icons/translation';
import { approvalFlow } from './icons/approval-flow';
import { designation } from './icons/designation';
import { config } from './icons/config';
import { branches } from './icons/branches';
import { phone } from './icons/phone';
import { notice } from './icons/notice';
import { info_request } from './icons/info_request';
import { briefcase2 } from './icons/briefcase2';
import { withdraw } from './icons/withdraw';
import { warn } from './icons/warn';
import { history } from './icons/history';
import { columns } from './icons/columns';
import { home } from './icons/home';
import { announce } from './icons/announce';
import { pdf2 } from './icons/pdf2';
import { lockIcon } from './icons/lock';
import { unlockIcon } from './icons/unlock';
import { userIcon } from './icons/usr';
import { dashboard } from './icons/dashboard';
import { user_management } from './icons/user_management';
import { item_management } from './icons/item_management';
import { settings } from './icons/setting';
import { report } from './icons/report';
import { content } from './icons/content_management';
import { pooled } from './icons/pooled_management';
import { bileteral } from './icons/bileteral_management';
import { manufacturer_management } from './icons/manufacturer_management';
import { incoterms_icon } from './icons/incoterms_icon';
import {itemCategory} from "./icons/item-category";
import {uom} from "./icons/uom";
import {itemType} from "./icons/itemType";
import { payment_mode } from './icons/mode_of_payment';
import { table_icon } from './icons/table_three_icon';
import { payment_edit } from './icons/payment_edit';
import { payment_view } from './icons/view_payment';
import { trash_payments } from './icons/trash_payment';
import { item_survey } from './icons/item_survey';

export interface SvgIcon {
  name: string;
  tag: any;
}

@Injectable({
  providedIn: 'root',
})
export class SvgIconsService {
  // REGISTER CUSTOMER SVG ICON IN THE ARRAY BELOW
  // THIS IS THE FAVORITE PLACE https://heroicons.com/
  // USE svgminify.com TO MINIFY AND GENERATE SVG CODES
  // USE flaticon.com TO DOWNLOAD FREE SVG IMAGES

  app_icons: SvgIcon[] = [
    { name: 'settings', tag: settingsSvg },
    { name: 'menu', tag: menuIcons.menuSettingsSvg },
    { name: 'call_tracking', tag: call_tracking },
    { name: 'cross', tag: cross },
    { name: 'check', tag: check },
    { name: 'pdf', tag: pdf },
    { name: 'reports', tag: reports },
    { name: 'users', tag: users },
    { name: 'add_users', tag: add_users },
    { name: 'reply', tag: reply },
    { name: 'forwards', tag: forwards },
    { name: 'help_desk', tag: help_desk },
    { name: 'handover', tag: handover },
    { name: 'ask_clarification', tag: ask_clarification },
    { name: 'flag1', tag: flag1 },
    { name: 'flag2', tag: flag2 },
    { name: 'clipboard', tag: clipboard },
    { name: 'closed_lock', tag: closed_lock },
    { name: 'institutions', tag: institutions },
    { name: 'upload', tag: uploadSvg },
    { name: 'add_shopping_cart', tag: add_shopping_cart },
    { name: 'data_base', tag: data_base },
    { name: 'done_check', tag: done_check },
    { name: 'closed_lock', tag: closed_lock },
    { name: 'clarification_alert', tag: clarification_alert },
    { name: 'bill_receipts', tag: bill_receipts },
    { name: 'searchIcon', tag: searchIcon },
    { name: 'document_download', tag: document_download },
    { name: 'upload', tag: uploadSvg },
    { name: 'people', tag: people },
    { name: 's_back_icon', tag: back_icon },
    { name: 'add_icon', tag: add_icon },
    { name: 'briefcase', tag: briefcase },
    { name: 'success', tag: success },
    { name: 'edit', tag: edit },
    { name: 'trash_delete', tag: trash_delete },
    { name: 's_view', tag: s_view },
    { name: 'calendar_month', tag: calendar_month },
    { name: 'credit_card', tag: credit_card },
    { name: 'bank_notes', tag: back_notes },
    { name: 'payment', tag: payment },
    { name: 'balance', tag: balace },
    { name: 'message', tag: message },
    { name: 'paperclip', tag: paperclip },
    { name: 'trashInbox', tag: trash_inbox },
    { name: 'notificatioBell', tag: notificatioBell },
    { name: 'sent', tag: sent },
    { name: 'inbox', tag: inbox },
    { name: 'back_arrow_left', tag: back_arrow_left },
    { name: 'image', tag: image },
    { name: 'question_mark', tag: question_mark },
    { name: 'arrow_down', tag: arrow_down },
    { name: 'star', tag: star },
    { name: 'more_menu', tag: more_menu },
    { name: 'forward', tag: forward },
    { name: 'tune_setting', tag: tune_setting },
    { name: 'add', tag: add },
    { name: 'back_arrow', tag: back_arrow },
    { name: 'backarrow', tag: backarrow },
    { name: 'end_message', tag: end_message },
    { name: 'wallet_account', tag: wallet_account },
    { name: 'transcations', tag: transcations },
    { name: 'money_wallet', tag: money_wallet },
    { name: 'bills', tag: bills },
    { name: 'waiver', tag: waiver },
    { name: 'requisition', tag: requisition },
    { name: 'save', tag: Save },
    { name: 'evaluate', tag: evaluate },
    { name: 'team', tag: team },
    { name: 'chevron_down', tag: chevron_down },
    { name: 'chevron_up', tag: chevron_up },
    { name: 'user_account', tag: user_account },
    { name: 'tasks', tag: tasks },
    { name: 'language', tag: language },
    { name: 'approved-cart', tag: approved_cart },
    { name: 'cancelled-options', tag: cancelledOptions },
    { name: 'redo-icon', tag: redo },
    { name: 'post-qualification', tag: post_qualification },
    { name: 'negotiation', tag: negotiation },
    { name: 'bidMeeting', tag: bidMeeting },
    { name: 'siteVisit', tag: siteVisitSvg },
    { name: 'cart', tag: cart_icon },
    { name: 'stock', tag: stock },
    { name: 'complain', tag: complain },
    { name: 'excel', tag: excel },
    { name: 'plus', tag: plus },
    { name: 'minus', tag: minus },
    { name: 'list', tag: list },
    { name: 'doc', tag: doc },
    { name: 'mp3', tag: mp3 },
    { name: 'mp4', tag: mp4 },
    { name: 'add_person', tag: add_person },
    { name: 'upload_file', tag: upload_file },
    { name: 'facebook', tag: facebook },
    { name: 'instagram', tag: instagram },
    { name: 'twitter', tag: twitter },
    { name: 'youtube', tag: youtube },
    { name: 'option', tag: option },
    { name: 'education', tag: education },
    { name: 'translation', tag: translation },
    { name: 'approval-flow', tag: approvalFlow },
    { name: 'designation', tag: designation },
    { name: 'config', tag: config },
    { name: 'branches', tag: branches },
    { name: 'phone', tag: phone },
    { name: 'notice', tag: notice },
    { name: 'info_request', tag: info_request },
    { name: 'briefcase2', tag: briefcase2 },
    { name: 'withdraw', tag: withdraw },
    { name: 'warn', tag: warn },
    { name: 'history', tag: history },
    { name: 'columns', tag: columns },
    { name: 'home', tag: home },
    { name: 'announce', tag: announce },
    { name: 'pdf2', tag: pdf2 },
    { name: 'lock', tag: lockIcon },
    { name: 'unlock', tag: unlockIcon },
    { name: 'user', tag: userIcon },
    { name: 'dashboard', tag: dashboard },
    { name: 'user_management', tag: user_management },
    { name: 'item_management', tag: item_management },
    { name: 'setting', tag: settings },
    { name: 'report', tag: report },
    { name: 'content', tag: content },
    { name: 'pooled', tag: pooled },
    { name: 'bileteral', tag: bileteral },
    { name: 'manufacturer_management', tag: manufacturer_management },
    { name: 'incoterms_icon', tag: incoterms_icon },
    {name: 'settings', tag: settingsSvg},
    {name: 'menu', tag: menuIcons.menuSettingsSvg},
    {name: 'call_tracking', tag: call_tracking},
    {name: 'cross', tag: cross},
    {name: 'check', tag: check},
    {name: 'pdf', tag: pdf},
    {name: 'reports', tag: reports},
    {name: 'users', tag: users},
    {name: 'add_users', tag: add_users},
    {name: 'reply', tag: reply},
    {name: 'forwards', tag: forwards},
    {name: 'help_desk', tag: help_desk},
    {name: 'handover', tag: handover},
    {name: 'ask_clarification', tag: ask_clarification},
    {name: 'flag1', tag: flag1},
    {name: 'flag2', tag: flag2},
    {name: 'clipboard', tag: clipboard},
    {name: 'closed_lock', tag: closed_lock},
    {name: 'institutions', tag: institutions},
    {name: 'upload', tag: uploadSvg},
    {name: 'add_shopping_cart', tag: add_shopping_cart},
    {name: 'data_base', tag: data_base},
    {name: 'done_check', tag: done_check},
    {name: 'closed_lock', tag: closed_lock},
    {name: 'clarification_alert', tag: clarification_alert},
    {name: 'bill_receipts', tag: bill_receipts},
    {name: 'searchIcon', tag: searchIcon},
    {name: 'document_download', tag: document_download},
    {name: 'upload', tag: uploadSvg},
    {name: 'people', tag: people},
    {name: 's_back_icon', tag: back_icon},
    {name: 'add_icon', tag: add_icon},
    {name: 'briefcase', tag: briefcase},
    {name: 'success', tag: success},
    {name: 'edit', tag: edit},
    {name: 'trash_delete', tag: trash_delete},
    {name: 's_view', tag: s_view},
    {name: 'calendar_month', tag: calendar_month},
    {name: 'credit_card', tag: credit_card},
    {name: 'bank_notes', tag: back_notes},
    {name: 'payment', tag: payment},
    {name: 'balance', tag: balace},
    {name: 'message', tag: message},
    {name: 'paperclip', tag: paperclip},
    {name: 'trashInbox', tag: trash_inbox},
    {name: 'notificatioBell', tag: notificatioBell},
    {name: 'sent', tag: sent},
    {name: 'inbox', tag: inbox},
    {name: 'back_arrow_left', tag: back_arrow_left},
    {name: 'image', tag: image},
    {name: 'question_mark', tag: question_mark},
    {name: 'arrow_down', tag: arrow_down},
    {name: 'star', tag: star},
    {name: 'more_menu', tag: more_menu},
    {name: 'forward', tag: forward},
    {name: 'tune_setting', tag: tune_setting},
    {name: 'add', tag: add},
    {name: 'back_arrow', tag: back_arrow},
    {name: 'backarrow', tag: backarrow},
    {name: 'end_message', tag: end_message},
    {name: 'wallet_account', tag: wallet_account},
    {name: 'transcations', tag: transcations},
    {name: 'money_wallet', tag: money_wallet},
    {name: 'bills', tag: bills},
    {name: 'waiver', tag: waiver},
    {name: 'requisition', tag: requisition},
    {name: 'save', tag: Save},
    {name: 'evaluate', tag: evaluate},
    {name: 'team', tag: team},
    {name: 'chevron_down', tag: chevron_down},
    {name: 'chevron_up', tag: chevron_up},
    {name: 'user_account', tag: user_account},
    {name: 'tasks', tag: tasks},
    {name: 'language', tag: language},
    {name: 'approved-cart', tag: approved_cart},
    {name: 'cancelled-options', tag: cancelledOptions},
    {name: 'redo-icon', tag: redo},
    {name: 'post-qualification', tag: post_qualification},
    {name: 'negotiation', tag: negotiation},
    {name: 'bidMeeting', tag: bidMeeting},
    {name: 'siteVisit', tag: siteVisitSvg},
    {name: 'cart', tag: cart_icon},
    {name: 'stock', tag: stock},
    {name: 'complain', tag: complain},
    {name: 'excel', tag: excel},
    {name: 'plus', tag: plus},
    {name: 'minus', tag: minus},
    {name: 'list', tag: list},
    {name: 'doc', tag: doc},
    {name: 'mp3', tag: mp3},
    {name: 'mp4', tag: mp4},
    {name: 'add_person', tag: add_person},
    {name: 'upload_file', tag: upload_file},
    {name: 'facebook', tag: facebook},
    {name: 'instagram', tag: instagram},
    {name: 'twitter', tag: twitter},
    {name: 'youtube', tag: youtube},
    {name: 'option', tag: option},
    {name: 'education', tag: education},
    {name: 'translation', tag: translation},
    {name: 'approval-flow', tag: approvalFlow},
    {name: 'designation', tag: designation},
    {name: 'config', tag: config},
    {name: 'branches', tag: branches},
    {name: 'phone', tag: phone},
    {name: 'notice', tag: notice},
    {name: 'info_request', tag: info_request},
    {name: 'briefcase2', tag: briefcase2},
    {name: 'withdraw', tag: withdraw},
    {name: 'warn', tag: warn},
    {name: 'history', tag: history},
    {name: 'columns', tag: columns},
    {name: 'home', tag: home},
    {name: 'announce', tag: announce},
    {name: 'pdf2', tag: pdf2},
    {name: 'lock', tag: lockIcon},
    {name: 'unlock', tag: unlockIcon},
    {name: 'user', tag: userIcon},
    {name: 'dashboard', tag: dashboard},
    {name: 'user_management', tag: user_management},
    {name: 'item_management', tag: item_management},
    {name: 'setting', tag: settings},
    {name: 'report', tag: report},
    {name: 'content', tag: content},
    {name: 'pooled', tag: pooled},
    {name: 'bileteral', tag: bileteral},
    {name: 'manufacturer_management', tag: manufacturer_management},
    {name: 'payment_mode', tag: payment_mode},
    {name: 'itemCategory', tag: itemCategory},
    {name: 'uom', tag: uom},
    {name: 'itemType', tag: itemType},
    {name: 'table_icon',  tag: table_icon},
    {name: 'payment_edit', tag: payment_edit},
    {name: 'payment_view', tag: payment_view},
    {name: 'trash_payments', tag: trash_payments},
    {name: 'item_survey', tag: item_survey}
  ];

  constructor() {}

  getType = (str: string) => (this.isSVG(str) ? 'SVG' : 'MATERIAL');

  isSVG = (str: string) => this.app_icons.find((x) => x?.name === str);
}
